import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import {
  attemptAssessment,
  attemptAssessmentResult,
} from "../services/awsServices";
import GradientButton from "./Button/GradientButton";
import LoadingCom from "./LoadingCom";
const AssessmentModal = ({ data, isModalOpen, setIsModalOpen }) => {
  const [assessment, setAssessment] = useState();
  // const [assessmentResult, setAssessmentResult] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log("🚀 ~ AssessmentModal ~ assessment:", assessment);
  const email = localStorage.getItem("username");
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const attemptAssessmentFun = async () => {
      setLoading(true); // Set loading to true when fetching data
      try {
        const res = await attemptAssessment(data?.id);
        console.log(res, "response assetemtn");
        if (res) {
          const schedules = res?.data?.data?.schedules;
          const assessmentResults = await Promise.all(
            schedules?.map((schedule) => {
              return attemptAssessmentResult(schedule.accessKey, email);
            })
          );
          // Combine schedules and assessment results into an object
          const assessmentData = {
            schedules: schedules,
            assessmentResults: assessmentResults,
          };
          // Set the combined data object in the state
          setAssessment(assessmentData);
        }
      } catch (error) {
        console.log("Error fetching assessment:", error);
      } finally {
        setLoading(false); // Set loading to false whether fetching is successful or not
      }
    };

    attemptAssessmentFun();
  }, [data?.id, email]); // Ensure email is included as a dependency if it's used inside useEffect

  return (
    <>
      <Modal
        width={"80%"}
        footer={false}
        // title="Basic Modal"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div dangerouslySetInnerHTML={{ __html: data?.defaultInstructions }} />
        <h1 className="font-bold">{data?.sections[0]?.name}</h1>
        <div
          dangerouslySetInnerHTML={{ __html: data?.sections[0]?.instructions }}
        />
        <p className="text-red-600 mt-2">
          Please use the same email address that you used to login.
        </p>
        {loading ? (
          <LoadingCom />
        ) : assessment?.assessmentResults[0]?.data?.data?.candidate?.email ? (
          assessment?.assessmentResults?.map((data, index) => {
            return (
              <div
                key={index}
                className="flex items-center justify-between bg-white rounded-lg p-4 shadow-md mb-4 mt-5"
              >
                <p className="text-lg font-semibold">
                  {/* {data?.data?.data?.candidate?.email} */}
                  {assessment?.schedules[index]?.name}
                </p>
                <p className="text-gray-600">
                  {data?.data?.data?.candidate?.testStatus?.completionMode
                    ? data?.data?.data?.candidate?.testStatus?.completionMode
                    : assessment?.schedules[index]?.status}
                </p>
                <GradientButton className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600">
                  <a
                    target="blank"
                    href={
                      data?.data?.data?.candidate?.testStatus?.pdfReport
                        ? data?.data?.data?.candidate?.testStatus?.pdfReport
                        : assessment?.schedules[index]?.accessUrl
                    }
                  >
                    {data?.data?.data?.candidate?.testStatus?.pdfReport
                      ? "Download Result"
                      : "Attempt Assessment"}
                  </a>
                </GradientButton>
              </div>
            );
          })
        ) : (
          assessment?.schedules?.map((data, id) => {
            return (
              <div
                key={id}
                className="flex items-center justify-between bg-white rounded-lg p-4 shadow-md mb-4 mt-5"
              >
                <p className="text-lg font-semibold">{data?.name}</p>
                <p className="text-gray-600">{data?.status}</p>
                <GradientButton
                  className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
                  onClick={() => window.open(data?.accessUrl)}
                >
                  Attempt Assessment
                </GradientButton>
              </div>
            );
          })
        )}
      </Modal>
    </>
  );
};
export default AssessmentModal;
